export const planetWatchBullets = [
  {
    name: "Top menu - Planet Watch tab",
    description: `At the top of the page, above the orange top menu, you'll see "Planet Watch" in green text. If you click on it, you'll be taken to the Planet Watch page.`,
  },
  {
    name: "App store",
    description: `On the Planet Watch page, you'll see a banner with "Planet Watch" in large text. Below this is a link to the Apple app store. By clicking on this link, you'll be able to download the app.`,
  },
];



// WEBPACK FOOTER //
// ./resources/assets/js/app/TeachersToolkit/TeachersToolkitHowTo/components/Sections/PlanetWatch/TTHTPlanetWatchSection.consts.js